import React, { useState, useEffect, useRef } from 'react';
import { konusmaciArr } from './KonusmacilarData';
import PageTitle from '../pagetitle/PageTitle';
import { Card, CardImg, Input, FormGroup, Label } from 'reactstrap';

const Speakers = () => {
  const [checkboxes, setCheckboxes] = useState({
    mayis19: true,
    bandirma: true,
    karadeniz: true,
    samsun: true
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [popupSrc, setPopupSrc] = useState(null);
  const popupRef = useRef(null);

  const handleCheckboxChange = (checkboxName) => {
    setCheckboxes({
      ...checkboxes,
      [checkboxName]: !checkboxes[checkboxName],
    });
  };

  const filterSpeakersByHall = (speaker) => {
    if (
      (checkboxes.mayis19 && speaker.hall === '19 Mayıs Salonu') ||
      (checkboxes.bandirma && speaker.hall === 'Bandırma Salonu') ||
      (checkboxes.karadeniz && speaker.hall === 'Karadeniz Salonu') ||
      (checkboxes.samsun && speaker.hall === 'Samsun Salonu')
    ) {
      return true;
    }
    return false;
  };

  const filterSpeakersBySearch = (speaker) => {
    const searchRegex = new RegExp(searchTerm, 'i');
    return searchRegex.test(speaker.name) || searchRegex.test(speaker.title);
  };

  const showPopup = (src) => {
    setPopupSrc(src);
  };

  const hidePopup = () => {
    setPopupSrc(null);
  };

  const searchSpeaker = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleOutsideClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      hidePopup();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <>
      <PageTitle name="Konuşmacılar" />
      <div className='container konusmacilarAll'>
        <div className="row">
          <div className='col-md-3 col-sm-12'>
            <div className='sidebar'>
              <div className='mb-3'>
                <h6>Arama</h6>
                <Input placeholder='Konu veya isme göre ara..' onChange={searchSpeaker}></Input>
              </div>

              <div>
                <h6>Salonlar</h6>
                <FormGroup check className='form-switch'>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={checkboxes.mayis19}
                      onChange={() => handleCheckboxChange('mayis19')}
                    />{' '}
                    19 Mayıs Salonu
                  </Label>
                </FormGroup>

                <FormGroup check className='form-switch'>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={checkboxes.bandirma}
                      onChange={() => handleCheckboxChange('bandirma')}
                    />{' '}
                    Bandırma Salonu
                  </Label>
                </FormGroup>

                <FormGroup check className='form-switch'>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={checkboxes.samsun}
                      onChange={() => handleCheckboxChange('samsun')}
                    />{' '}
                    Samsun Salonu
                  </Label>
                </FormGroup>

                <FormGroup check className='form-switch'>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={checkboxes.karadeniz}
                      onChange={() => handleCheckboxChange('karadeniz')}
                    />{' '}
                    Karadeniz Salonu
                  </Label>
                </FormGroup>
              </div>
            </div>
          </div>

          <div className='col-md-9 col-sm-12'>
            <div className='row'>
              {konusmaciArr
                .filter(filterSpeakersByHall)
                .filter(filterSpeakersBySearch)
                .map((speaker, index) => (
                  <div className="col-md-4 my-3" key={index}>
                    <Card hall={speaker?.hall} name={speaker?.name} title={speaker?.title}>
                      <CardImg src={speaker.src} onClick={() => showPopup(speaker.src)} />
                    </Card>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {popupSrc && (
          <div className="popup" onClick={hidePopup} ref={popupRef}>
            <div className="popupCont">
              <div className="figure">
                <span className="kapat" onClick={hidePopup}><i className="bi bi-x-lg"></i></span>
                <img src={popupSrc} alt="Popup Image" />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Speakers;
